import { format, parseISO } from 'date-fns';

import { MeasureType } from '../types';

export function formatMeasureValue(
  value: number | string | null | undefined,
  type: string | undefined,
  emDash = '—'
): string {
  if (value == null) return emDash;

  if (typeof value === 'string') {
    if (type === 'period') {
      try {
        const d = parseISO(value);
        return format(d, 'MMM yyyy');
      } catch {
        // fall through to return raw value
      }
    }
    return value;
  }

  switch (type?.toLowerCase()) {
    case MeasureType.HOURS:
      return `${Number(value).toFixed(1)} h`;
    case MeasureType.MONEY:
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(Number(value));
    case MeasureType.PERCENT:
      return `${Number(value).toFixed(1)}%`;
    case MeasureType.RATIO:
      return Number(value).toFixed(2);
    case MeasureType.NUMBER:
      return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(Number(value));
    default:
      return String(value);
  }
}

export const CHART_COLORS = [
  'hsl(var(--chart-1))',
  'hsl(var(--chart-2))',
  'hsl(var(--chart-3))',
  'hsl(var(--chart-4))',
  'hsl(var(--chart-5))',
];

export const TARGET_COLORS = ['#f97316', '#a855f7', '#14b8a6', '#ec4899', '#eab308'];
